// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation EnableTwoFactorMutation {
    enableTwoFactor {
      twoFactorEnabled
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
